import { motion } from "framer-motion";
import { stagger, fadeUp } from "@/components/Reveal";
import { Handshake, PhoneCall, Clock, TrendingUp } from "lucide-react";

const METRICS = [
  { icon: Handshake, value: "100+", label: "Strategic relationships opened across NZ & AU" },
  { icon: PhoneCall, value: "1,000s", label: "Of prospecting calls & follow-ups made for clients" },
  { icon: Clock, value: "5 days", label: "A week of pipeline support, so you never miss a lead" },
  { icon: TrendingUp, value: "2", label: "Markets covered — New Zealand & Australia" },
];

export default function Stats() {
  return (
    <section id="results" data-testid="stats-metrics-section" className="py-16 sm:py-20 bg-emerald-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {METRICS.map((m, i) => (
            <motion.div key={m.value + i} variants={fadeUp} data-testid={`stat-metric-${i}`} className="text-center">
              <span className="mx-auto w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center mb-4">
                <m.icon className="w-5 h-5 text-white" />
              </span>
              <p className="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tight">{m.value}</p>
              <p className="mt-2 text-sm text-emerald-50/90 leading-snug max-w-[220px] mx-auto">{m.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
